import WOW from "wowjs";

// Animations
export const initWowLibrary = () => {
  window.wow = new WOW.WOW({
    live: false
  });
  // Removed the disappearance of the class animated, caused errors in the console
  window.wow.resetAnimation = function() {};
  window.wow.init();
};